require('../../modules/es6.object.statics-accept-primitives');
module.exports = require('../../modules/$').core.Object.isFrozen;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/is-frozen.js
 ** module id = 109
 ** module chunks = 0
 **/